import React, { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useAuth } from '../../hooks/useAuth';
import { WebApiCalls } from '../../webApiCalls/WebApiCalls';
import { toast } from 'react-toastify';
import CommonModal from '../Modals/CommonModal';
import Spinner from 'react-bootstrap/Spinner';
const PaymentSettings = () => {
    const { getToken } = useAuth();
    const [loading, setLoading] = React.useState(false);
    const [stripeAccount, setStripeAccount] = React.useState({ charges_enabled: false });
    const [showDelModal, setShowDelModal] = React.useState(false);

    const handleClose = () => {
        setShowDelModal(false);
    };
    const deleteHostStripeAccount = () => {
        try {
            setLoading(true);
            const token = getToken();

            if (token)
                new WebApiCalls()
                    .deleteStripeAccount(token)
                    .then((res) => {
                        toast.success('Deleted successfully.');
                        getStripeAccount();
                        setLoading(false);
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };
    const handleAttachAccount = async () => {
        try {
            setLoading(true);
            const token = getToken();

            if (token)
                new WebApiCalls()
                    .stripeConnectAccount(token, { baseUrl: '' })
                    .then((res) => {
                        if (res.url) {
                            window.open(res.url, '_blank');
                        }
                        setLoading(false);
                    })
                    .catch((err) => {
                        setLoading(false);
                    });
        } catch (error) {
            console.log('ERROR while updating Bulk', error);
        }
    };

    const getStripeAccount = () => {
        setLoading(true);

        const token = getToken();

        if (token)
            new WebApiCalls()
                .getStripeAccount(token)
                .then((res) => {
                    setStripeAccount(res?.account);
                    setLoading(false);
                })
                .catch((err) => {
                    setLoading(false);
                });
    };

    useEffect(() => {
        getStripeAccount();
    }, [stripeAccount?.charges_enabled]);

    return (
        <div>
            <CommonModal handleClose={handleClose} show={showDelModal} handleDelete={deleteHostStripeAccount} text={'Are you sure, you want to remove stripe account?'} />

            {!stripeAccount?.charges_enabled && <h5 className="text-center mt-4">Please create stripe account to receive payment from commuters.</h5>}
            <div className="text-center">
                {loading && !stripeAccount?.payouts_enabled && !stripeAccount?.details_submitted && (
                    <Spinner animation="border" role="status" className="text-black ">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                )}
                <div>
                    {!stripeAccount?.charges_enabled && (
                        <Button className="mt-4" disabled={loading} onClick={handleAttachAccount}>
                            {loading ? 'Connect...' : 'Connect'}
                        </Button>
                    )}
                </div>
                {stripeAccount?.payouts_enabled && stripeAccount?.details_submitted ? (
                    <div className="d-flex align-items-center justify-content-center flex-column mt-4">
                        <div className="d-flex align-items-center">
                            <p className="greyparagraph4">Account Type:</p>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="boldparagraph2 font-12">{stripeAccount?.type}</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center">
                            <p className="greyparagraph4">Country:</p>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="boldparagraph2 font-12">{stripeAccount?.country}</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center">
                            <p className="greyparagraph4">Default Currency:</p>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="boldparagraph2 font-12">{stripeAccount?.default_currency}</p>
                            </div>
                        </div>
                        <div className="d-flex align-items-center">
                            <p className="greyparagraph4">Balance:</p>
                            <div className="d-flex align-items-center justify-content-between">
                                <p className="boldparagraph2 font-12">$ {stripeAccount?.available[0].amount / 100}</p>
                            </div>
                        </div>

                        <div className="d-flex gap-2">
                            <Button
                                onClick={() => setShowDelModal(true)}
                                className="w-110 h-40 mt-4 custom-revert-border font-17 mb-4 color-black"
                                label={loading ? '...' : 'Disconnect'}
                            >
                                {' '}
                                Disconnect
                            </Button>
                        </div>
                    </div>
                ) : (
                    <div className="text-center mt-3">Please fill all necessary details to receive payouts.</div>
                )}
            </div>
        </div>
    );
};

export default PaymentSettings;
